import { render, staticRenderFns } from "./platform_user_init_import.vue?vue&type=template&id=cd3e7d5e&scoped=true"
import script from "./platform_user_init_import.vue?vue&type=script&lang=js"
export * from "./platform_user_init_import.vue?vue&type=script&lang=js"
import style0 from "./platform_user_init_import.vue?vue&type=style&index=0&id=cd3e7d5e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3e7d5e",
  null
  
)

export default component.exports